import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 0px ${o => o.theme.dimensions.layout.sidePadding.md}px;
`
